import React, { Component } from "react";
import ReactDataSheet from "react-datasheet";
import "react-datasheet/lib/react-datasheet.css";

class ImportCPF extends Component {
  state = {
    grid: [[{ value: "" }]],
    cpfs: [],
  };

  componentDidUpdate(oldProps) {
    const { data } = this.props;
    if (oldProps.data !== data) {
      const { cpf_list } = data;

      if (cpf_list !== null && cpf_list !== undefined && cpf_list !== []) {
        const grid = cpf_list.map((cpf) => [
          {
            value: cpf,
          },
        ]);

        this.setState({ grid });
      }
    }
  }

  handleCellsChanged = (changes, additions) => {
    const { grid } = this.state;
    const { onChange, limit: MAX_CPF_LIST } = this.props;

    if (!additions) {
      if (changes[0].row === grid.length - 1) {
        grid[changes[0].row + 1] = [{ value: "" }];
        this.setState({ grid });
      }
    }

    let newGrid = grid.map((row) => [...row]);

    changes.forEach(({ cell, row, col, value }) => {
      newGrid[row][col] = { ...newGrid[row][col], value };
    });

    if (additions) {
      additions.forEach(({ cell, row, col, value }) => {
        if (!newGrid[row]) {
          newGrid[row] = [{ value: "" }];
        }

        if (newGrid[row][col]) {
          newGrid[row][col] = { ...newGrid[row][col], value };
        }
      });
    }

    if (newGrid.length > MAX_CPF_LIST) {
      newGrid = newGrid.slice(0, MAX_CPF_LIST);

      alert(
        `O limite máximo de CPFs é ${MAX_CPF_LIST}, todos os produtos que excederam o limite não foram importados.`
      );
    }

    const cpfsArray = newGrid.flatMap((item) => item[0].value);

    onChange(cpfsArray);

    this.setState({ grid: newGrid });
    this.setState({ cpfs: cpfsArray });
  };

  handleDoubleClick = (onDoubleClick) => {
    alert(
      "Edição de célula ativa! clique uma vez apenas na célula para colar dados da planilha."
    );

    onDoubleClick();
  };

  render() {
    const { grid, cpfs } = this.state;
    const { limit: MAX_CPF_LIST } = this.props;

    return (
      <div className="datasheet">
        <ReactDataSheet
          data={grid}
          valueRenderer={(cell) => cell.value}
          onCellsChanged={this.handleCellsChanged}
          sheetRenderer={(props) => (
            <table {...props}>
              <thead>
                <tr>
                  <td>CPF</td>
                </tr>
              </thead>
              <tbody>{props.children}</tbody>
            </table>
          )}
          cellRenderer={(props) => (
            <td
              onMouseDown={props.onMouseDown}
              onDoubleClick={() => this.handleDoubleClick(props.onDoubleClick)}
            >
              {props.children}
            </td>
          )}
        />

        <small>
          Para colar dados de uma planilha, clique apenas uma vez na célula e
          cole.
          <br />
          Para editar dados da célula, clique duas vezes.
          <br />
          <p>
            {" "}
            {cpfs.length}/{MAX_CPF_LIST} CPFs
          </p>
        </small>
      </div>
    );
  }
}

export default ImportCPF;
